import { Component, HostListener, inject } from '@angular/core';
import { DirtyChangesDialogService } from './dirty-changes-dialog.service';

@Component({
  selector: 'app-dirty-changes-dialog',
  standalone: true,
  templateUrl: './dirty-changes-dialog.component.html',
  styleUrl: './dirty-changes-dialog.component.scss'
})
export class DirtyChangesDialogComponent {
  readonly dialog = inject(DirtyChangesDialogService);

  @HostListener('document:keydown.escape')
  keepEditing(): void {
    if (this.dialog.request()) this.dialog.keepEditing();
  }
}
